<template>
  <div class="books-grid">
    <router-link
        v-for='(book, index) in books'
        :key='index'
        class='book'
        :to="{
                name: 'pages.book',
                params: {id: book.id},
                query: {page: book.current_page}
            }"
    >
      <img :src="baseUrl + '/storage/' + book.cover" alt="Cover image">

      <div class="rating">
        <span class="star"></span>
        <span class="star"></span>
        <span class="star"></span>
        <span class="star"></span>
        <span class="star"></span>
      </div>

      <h4>{{ book.name }}</h4>
      <p class="light">Door {{ book.author }}</p>

      <span class="btn" v-if="book.current_page === 1">Begin met lezen</span>
      <span class="btn" v-else>Lees verder</span>
    </router-link>
  </div>
</template>

<script>
import {baseUrl} from '@/http/utl.js';

export default {
  name: "BooksGrid",
  props: [
    "books",
  ],
  data() {
    return {
      baseUrl: baseUrl,
    };
  },
};
</script>
